import { MAP_MARKER_SIZES } from '@/core/constants/dashboard-map.constants';

export interface LeaderLineState {
  selected?: boolean;
  hovered?: boolean;
}

/**
 * Subtle leader-line visual weight — supports marker↔card, does not dominate.
 */
export function getLeaderLineWidth(state: LeaderLineState): number {
  if (state.selected) {
    return MAP_MARKER_SIZES.leaderWidthSelected;
  }
  if (state.hovered) {
    return MAP_MARKER_SIZES.leaderWidthHover;
  }
  return MAP_MARKER_SIZES.leaderWidth;
}

export function getLeaderLineAlpha(state: LeaderLineState): number {
  if (state.selected) {
    return MAP_MARKER_SIZES.leaderAlphaSelected;
  }
  if (state.hovered) {
    return MAP_MARKER_SIZES.leaderAlphaHover;
  }
  return MAP_MARKER_SIZES.leaderAlpha;
}

export function useMapLeaderLines() {
  return {
    getLeaderLineWidth,
    getLeaderLineAlpha,
  };
}
